export const getStatusInfo = (status) => {
  const statusInfo = {
    SUBMITTED: { labelKey: 'payrollExp.submittedLabel', descKey: 'payrollExp.submittedDesc', variant: 'default',  canExport: true },
    APPROVED:  { labelKey: 'payrollExp.approvedLabel',  descKey: 'payrollExp.approvedDesc',  variant: 'success',  canExport: true },
    CLOSED:    { labelKey: 'payrollExp.closedLabel',    descKey: 'payrollExp.closedDesc',    variant: 'outline',  canExport: true },
  };
  return statusInfo[String(status || '').toUpperCase()] || statusInfo.SUBMITTED;
};

// Period statuses that forbid (re)calculation — once a period is closed/locked/paid,
// the backend rejects recalculation and the UI must disable the action.
const LOCKED_PERIOD_STATUSES = new Set(['closed', 'locked', 'paid', 'archived']);

export const isPeriodLocked = (period) =>
  LOCKED_PERIOD_STATUSES.has(String(period?.status || '').toLowerCase());

// Format a date (Date or ISO string) as dd/MM/yyyy regardless of the browser locale,
// avoiding the US M/D/YYYY default of toLocaleDateString().
export const formatDateFr = (value) => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
  }).format(d);
};

export const makeFormatCurrency = (currency, locale) => (amount) =>
  amount
    ? new Intl.NumberFormat(locale || 'fr-TN', { style: 'currency', currency: currency || 'TND' }).format(amount)
    : `0 ${currency || 'TND'}`;

export const formatTND = makeFormatCurrency('TND', 'fr-TN');
